export class Consultant {
    id_agency?: number;
    name!: string;
    surname!: string;
    matricola!: string;
    email!: string;
}
